import { RelatorioComposicaoReceitasHorizontalPdfResponse } from "core/features/relatorios/typings";
import { PDFLayout } from "ui/components/PDF";
import PDFTable from "ui/components/PDF/Table";
import useRelatorioComposicaoReceitasHorizontalPdfColumns from "./hooks/useRelatorioComposicaoReceitasHorizontalPdfColumns";
import { View } from "@react-pdf/renderer";
import * as _ from "lodash";
import ResumoPorCategoria from "components/Relatorio/ResumoPorCategoria";
import { RelatorioComposicaoReceitasHorizontalItem } from "features/relatorios/typings";
interface PDFRelatorioComposicaoReceitasHorizontalProps {
  data: RelatorioComposicaoReceitasHorizontalPdfResponse;
  includeDocumentWrapper?: boolean;
}

function getGroups(
  data: RelatorioComposicaoReceitasHorizontalPdfResponse,
  groupByFields?: string[]
) {
  if (!groupByFields?.length) {
    return [];
  }

  if (groupByFields?.length) {
    const groups = _.groupBy(data.items, (item) => {
      let key = "";

      groupByFields.forEach((field) => {
        if (field in item) {
          key += item[field as keyof RelatorioComposicaoReceitasHorizontalItem];
        }
      });

      return key;
    });

    const sortedGroupKeys = Object.keys(groups).sort((a, b) =>
      a.localeCompare(b)
    );

    const groupedItems: {
      items: RelatorioComposicaoReceitasHorizontalItem[];
      total: number;
    }[] = [];

    for (const group of sortedGroupKeys) {
      const groupItems = groups[group];

      const groupTotal = groupItems.reduce((acc, next) => {
        const categoriasASomar = Object.entries(next.composicoes);

        const soma = categoriasASomar.reduce(
          (acc, [_, valor]) => (acc += valor),
          0
        );

        return (acc += soma);
      }, 0);

      groupedItems.push({
        items: groupItems,
        total: groupTotal,
      });
    }

    return groupedItems;
  }

  return [];
}

function PDFRelatorioComposicaoReceitasHorizontal({
  data,
  includeDocumentWrapper = true,
}: PDFRelatorioComposicaoReceitasHorizontalProps) {
  const columns = useRelatorioComposicaoReceitasHorizontalPdfColumns({
    todasAsCategorias: data?.todasAsCategorias,
    groupByFields: data?.groupByFields,
  });

  let groups: {
    items: RelatorioComposicaoReceitasHorizontalItem[];
    total: number;
  }[] = [];

  if (data.groupByFields?.length) {
    groups = getGroups(data, data.groupByFields);
  }

  return (
    <PDFLayout
      includeDocument={includeDocumentWrapper}
      fontSize={7}
      assinaturas={data?.assinaturas}
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title: `Relatório de receitas com composições horizontal`,
        subTitle: data?.periodo,
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
      orientation="landscape"
    >
      {data?.groupByFields?.length ? (
        <>
          {groups?.map((group, index) => (
            <View
              key={index}
              style={{
                marginBottom: 16,
              }}
            >
              <PDFTable
                columns={columns}
                data={group.items}
                totalRow={group.total}
                tableHeaderVariant="rowLike"
              />
            </View>
          ))}
        </>
      ) : (
        <PDFTable
          columns={columns}
          data={data.items}
          tableHeaderVariant="rowLike"
        />
      )}

      {data ? (
        <View
          style={{
            marginTop: 32,
          }}
        >
          <ResumoPorCategoria data={data} />
        </View>
      ) : null}
    </PDFLayout>
  );
}

export default PDFRelatorioComposicaoReceitasHorizontal;
